module.exports = __webpack_public_path__ + "img/3.ca5fc376.jpg";